import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function SellerRegModal() {
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    companyLocation: "",
    companyEmail: "",
    termsAccepted: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleRegister = () => {
    if (!formData.termsAccepted) {
      alert("Please accept the terms & policy.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    alert("Registration successful!");
    setModalOpen(false);
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        className="bg-green-500 text-white px-4 py-2 w-40 rounded hover:bg-green-600"
        onClick={() => setModalOpen(true)}
      >
        Add Seller
      </button>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-12 w-[800px] relative">
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-sm"
              onClick={() => setModalOpen(false)}
            >
              ✖
            </button>

            <h2 className="text-center text-2xl font-bold mb-6 mt-5">Seller</h2>

            <div className="grid grid-cols-2 gap-20">
              {/* Personal Info */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Personal info</h3>

                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full mb-3 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email or Phone"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full mb-3 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />

                <div className="relative mb-3">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                  />
                  <span
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-3 top-3 cursor-pointer text-gray-400"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                  />
                  <span
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    className="absolute right-3 top-3 cursor-pointer text-gray-400"
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/* Company Info */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Company info</h3>

                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  className="w-full mb-3 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />

                <input
                  type="text"
                  name="companyLocation"
                  placeholder="Company Location"
                  value={formData.companyLocation}
                  onChange={handleInputChange}
                  className="w-full mb-3 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />

                <input
                  type="email"
                  name="companyEmail"
                  placeholder="Company Email"
                  value={formData.companyEmail}
                  onChange={handleInputChange}
                  className="w-full mb-3 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />
                 {/* Terms & Register */}
            <div className="flex items-center mt-4">
              <input
                type="checkbox"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleInputChange}
                className="mr-2"
              />
              <label className="text-sm">
                I understood the{" "}
                <a href="#" className="text-green-500 hover:underline">
                  terms & policy
                </a>
                .
              </label>
            </div>
              </div>
            </div>

           

           <div className="flex justify-center">
           <button
              type="button"
              onClick={handleRegister}
              className=" w-60 mt-10 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
            >
              Register
            </button>
           </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SellerRegModal;
